<template>
    <div class="controlplan">
        <h1>{{ $t('an_cphygienecode', { ns: 'analytics' }) }}</h1>
        <HygienecodeJaarschema />
    </div>
</template>

<script>
import HygienecodeJaarschema from './HygienecodeJaarschema.vue'

export default {
    name: 'ControlPlanBase',
    data: function () {
        return {
        };
    },
    components: {
        HygienecodeJaarschema
    },
    computed: {
    },
    methods: {
    },
    mounted: function () {
    },
    created() {
    }
};
</script>

<style scoped></style>
